import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function WhyTipsFail() {
  const failedTips = ['Pon ruido blanco', 'Haz una rutina', 'Hazlo dormir más temprano', 'No lo cargues tanto', 'Déjalo llorar (y aguanta)'];
  return <section className="py-20 px-4 bg-[#0c1425]" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-serif text-cream mb-6" data-id="element-182">
            Por qué los consejos que ves en redes no te están sirviendo
          </h2>
          <p className="text-xl text-amber-100/80 mb-8" data-id="element-183">
            Porque te dan piezas sueltas sin tablero:
          </p>

          <div className="space-y-4 mb-10" data-id="element-184">
            {failedTips.map((tip, index) => <div key={index} className="flex items-center text-amber-200/40 line-through decoration-amber-500/50 decoration-2" data-id="element-185">
                <X className="w-5 h-5 mr-3 text-red-400/50 shrink-0" data-id="element-186" />
                <span className="text-lg" data-id="element-187">{tip}</span>
              </div>)}
          </div>

          <p className="text-2xl font-serif text-amber-400 italic mb-8" data-id="element-188">
            Eso no es un plan. Es un buffet de opiniones.
          </p>

          <div className="space-y-6 text-lg text-amber-50/90 leading-relaxed" data-id="element-189">
            <p data-id="element-190">
              Y cuando estás agotada, lo único que te sale es lo más rápido:{' '}
              <br data-id="element-191" />
              <span className="font-bold text-amber-200" data-id="element-192">
                el botón máximo
              </span>{' '}
              (pecho/mecer/auto/lo que sea).
            </p>
            <p data-id="element-193">
              Entonces tu bebé aprende: <br data-id="element-194" />
              <span className="italic" data-id="element-195">
                "Cuando me despierto, esto es lo que pasa."
              </span>
            </p>
            <p className="text-amber-200/80 border-l-4 border-amber-500/40 pl-4 py-2 bg-amber-900/10" data-id="element-196">
              No es manipulación. Es repetición.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}